import { combineReducers } from "redux";
import appNotif from "./appNotif";
import exam from "./exam";
import loginForm from "./loginForm";

const appReducer = combineReducers({
  appNotif,
  exam,
  loginForm,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
